import React from 'react';
import {Image, ImageProps} from '@chakra-ui/react';

export const IntentHighIcon = (props: ImageProps) => (
  <Image src="/intent_high.svg" alt="High Intent" boxSize="24px" {...props} />
);

export const IntentMediumIcon = (props: ImageProps) => (
  <Image src="/intent_med.svg" alt="Medium Intent" boxSize="24px" {...props} />
);

export const IntentLowIcon = (props: ImageProps) => (
  <Image src="/intent_low.svg" alt="Low Intent" boxSize="24px" {...props} />
);

export const IntentNoneIcon = (props: ImageProps) => (
  <Image src="/intent_none.svg" alt="No Intent" boxSize="24px" {...props} />
);

const IntentTierIcons = {
  high: IntentHighIcon,
  medium: IntentMediumIcon,
  low: IntentLowIcon,
  none: IntentNoneIcon,
} as const;

export const IntentIcon = ({
  tier,
  ...props
}: {tier?: 'high' | 'medium' | 'low'} & ImageProps) => {
  const Icon = IntentTierIcons[tier ?? 'none'];
  return <Icon {...props} />;
};
